import React from 'react';

const Contact = () => {
  return (
    <div className="corporate-contact-page">
      <section 
        className="corporate-hero"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">Professional Photography Services</div>
            <h1>Let's Discuss Your Project</h1>
            <p>Connect with our team of professional photographers and videographers.</p>
          </div>
        </div>
      </section>

      <section className="contact-methods">
        <div className="container">
          <div className="section-header">
            <h2>Get in Touch</h2>
            <p>Choose your preferred method of communication</p>
          </div>
          <div className="methods-grid">
            <div className="method-card">
              <div className="method-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <h3>Call Us</h3>
              <p>Speak directly with our team</p>
              <a href="tel:+919347821691" className="method-link">+91 9347821691</a>
            </div>
            
            <div className="method-card">
              <div className="method-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <h3>Email Us</h3>
              <p>Send us your project details</p>
              <a href="mailto:dvistudios25@gmail.com" className="method-link">dvistudios25@gmail.com</a>
            </div>
            
            <div className="method-card">
              <div className="method-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                </svg>
              </div>
              <h3>WhatsApp</h3>
              <p>Quick chat and file sharing</p>
              <a href="https://wa.me/919347821691" className="method-link">Start Chat</a>
            </div>
            
            <div className="method-card">
              <div className="method-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <h3>Visit Us</h3>
              <p>Meet us in person</p>
              <span className="method-link">Hyderabad, India</span>
            </div>
            
            <div className="method-card">
              <div className="method-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                  <line x1="8" y1="21" x2="16" y2="21"/>
                  <line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
              </div>
              <h3>Video Call</h3>
              <p>Schedule a consultation</p>
              <a href="mailto:dvistudios25@gmail.com?subject=Video Consultation Request" className="method-link">Book Call</a>
            </div>
            
            <div className="method-card">
              <div className="method-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12,6 12,12 16,14"/>
                </svg>
              </div>
              <h3>Business Hours</h3>
              <p>When we're available</p>
              <span className="method-link">Mon-Sat: 9AM-7PM</span>
            </div>
            
            <div className="method-card">
              <div className="method-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14.828 14.828a4 4 0 0 1-5.656 0M9 10h.01M15 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
                </svg>
              </div>
              <h3>Social Media</h3>
              <p>Follow us for updates</p>
              <a href="https://www.instagram.com/dvi.studios" className="method-link">@dvi.studios</a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;